<template>
  <b-form-group
    label-class="mb-0 label-title"
    :label="item.title"
    label-for="multiselect-form__item"
    :description="item.helpText"
  >
    <v-select
      v-model="item.value"
      :options="options || item.values"
      :disabled="item.disabled"
      :searchable="true"
      :clearable="true"
      :multiple="true"
      :class="{ saving: saving, saved: saved, 'form-multiselect': true }"
      placeholder="-- Please Select --"
      @input="valueChanged"
    ></v-select>
  </b-form-group>
</template>

<script>
import FormItem from "./FormItem";
import vSelect from "vue-select";
import { debounce } from "lodash";
import { EventBus } from "../../event-bus";

export default {
  name: "MultiSelectFormItem",
  extends: FormItem,
  components: {
    vSelect,
  },
  props: ["item", "options"],
  data() {
    return {
      saving: false,
      saved: false,
    };
  },
  created() {
    this.debouncedSave = debounce(() => {
      this.saved = true;
      this.saving = false;
      setTimeout(() => {
        this.saved = false;
      }, 1000);
    }, 1000);
  },
  mounted() {
    // Initialize as array if not already
    if (!Array.isArray(this.item.value)) {
      this.item.value = this.item.value ? [this.item.value] : [];
    }
  },
  methods: {
    valueChanged(event) {
      console.log('MultiSelect received:', event);
      // Strip Vue reactivity to get plain array
      const plainArray = JSON.parse(JSON.stringify(event || []));
      console.log('MultiSelect emitting:', plainArray);
      this.item.value = plainArray;
      this.$emit("valueChanged", plainArray);
      this.saving = true;
      this.saved = false;
      EventBus.$emit("form-saving-started");
      this.debouncedSave();
    },
  },
};
</script>

<style scoped>
.form-multiselect {
  transition: all 0.3s ease;
}

.saving {
  border-color: #ffc107 !important;
}

.saved {
  border-color: #28a745 !important;
}
</style>
